import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
	name: 'secondsToMinutesSeconds'
})
export class SecondsToMinutesSecondsPipe implements PipeTransform {
	transform(seconds: number): string {
		// Disabling no null tslint rule as javascript date needs null for this constructor
		const date = new Date(null); // tslint:disable-line
		if (seconds && !isNaN(seconds)) {
			date.setSeconds(seconds); // specify value of SECONDS

			return date.toISOString().substr(14, 5);
		}

		return seconds?.toString();
	}
}
